import React, { useState } from "react";

const UploadPost = ({ onNext, data }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(
    data || {
      title: "",
      description: "",
      mediaLink: "",
    }
  );

  // Sync state when data prop changes (e.g., when navigating back)
  React.useEffect(() => {
    if (data) {
      setFormData({
        title: data.title || "",
        description: data.description || "",
        mediaLink: data.mediaLink || "",
      });
    }
  }, [data]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validation
    if (!formData.title.trim()) {
      alert("Please enter a post title");
      return;
    }

    if (!formData.mediaLink.trim()) {
      alert("Please enter a media link");
      return;
    }

    setLoading(true);
    // Pass formData to parent
    onNext({ uploadPost: formData });
    setLoading(false);
  };

  return (
    <div>
      <h1 className="text-xl lg:text-2xl font-semibold mb-4">Upload Post</h1>
      <p className="text-gray-600 mb-6 text-sm md:text-base lg:text-lg">
         This is where you can upload your post details.
      </p>

      <form className="space-y-4" onSubmit={handleSubmit}>
        {/* Post Title */}
        <div>
          <label className="block text-sm md:text-base lg:text-lg font-medium text-gray-700">
            Post Title
          </label>
          <input
            type="text"
            placeholder="Enter post title..."
            className="w-full border border-gray-300 rounded-md p-2 mt-1 focus:border-orange-500 focus:ring-orange-500"
            value={formData.title}
            onChange={(e) =>
              setFormData({ ...formData, title: e.target.value })
            }
          />
        </div>

        {/* Post Description */}
        <div>
          <label className="block text-sm md:text-base lg:text-lg font-medium text-gray-700">
            Post Description
          </label>
          <textarea
            placeholder="Write a short description..."
            rows={4}
            className="w-full border border-gray-300 rounded-md p-2 mt-1 focus:border-orange-500 focus:ring-orange-500"
            value={formData.description}
            onChange={(e) =>
              setFormData({ ...formData, description: e.target.value })
            }
          />
        </div>

        {/* Media Link */}
        <div>
          <label className="block text-sm md:text-base lg:text-lg font-medium text-gray-700">
            Media Link
          </label>
          <input
            type="url"
            placeholder="Paste image or video URL..."
            className="w-full border border-gray-300 rounded-md p-2 mt-1 focus:border-orange-500 focus:ring-orange-500"
            value={formData.mediaLink}
            onChange={(e) =>
              setFormData({ ...formData, mediaLink: e.target.value })
            }
          />
          <p className="text-xs md:text-sm lg:text-base text-gray-500 mt-1">
            Example: https://instagram.com/p/xyz123
          </p>
        </div>

        {/* Buttons */}
        <div className="flex justify-end pt-4">
          <button
            type="submit"
            disabled={loading}
            className={`px-5 py-2 rounded-md text-white transition duration-300 ${loading
                ? "bg-orange-300 cursor-not-allowed"
                : "bg-orange-500 hover:bg-orange-600"
              }`}
          >
            {loading ? "Saving..." : "Next"}
          </button>
        </div>

      </form>
    </div>
  );
};

export default UploadPost;